import { Box } from "@mui/material";
import { useState } from "react";
import { MembershipRequest } from "../service/model/membership.model";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import * as membershipSlice from "../features/memberships/membership.slice";
import Loader from "../components/loader";
import useMemberships from "../hooks/use-memberships";
import MembershipTable from "../features/memberships/components/membership-table";
import MembershipForm from "../features/memberships/components/membership-form";
import { selectLoggedInUser } from "../features/auth/auth.slice";
import CreateButton from "../components/create-button";

const Memberships = () => {
    const dispatch = useAppDispatch();
    const loggedInUserDetails = useAppSelector(selectLoggedInUser);
    const loggedInUser = loggedInUserDetails?.user;
    const [showMembershipForm, setShowMembershipForm] = useState(false);
    const isLoading = useAppSelector(membershipSlice.selectIsLoading);

    const [memberships] = useMemberships();

    const handleSubmit = (data: MembershipRequest) => {
        loggedInUser && dispatch(membershipSlice.createMembership({ ...data, })).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowMembershipForm(false);
            }
        });
    };

    return (
        <div>
            {isLoading &&
                <Loader />
            }
            {memberships &&
                <>
                    <Box sx={{ mb: "12px" }}>
                        <CreateButton variant="contained" onClick={() => setShowMembershipForm(true)} style={{ marginBottom: "12px" }}>Add Membership</CreateButton>
                    </Box>
                    <MembershipTable memberships={memberships} />
                    {showMembershipForm &&
                        <MembershipForm membership={undefined} editable={true} onClose={() => setShowMembershipForm(false)} onSubmit={handleSubmit} />
                    }
                </>
            }
        </div>
    )
}

export default Memberships;